import React from "react"
import Col from "react-bootstrap/Col"
import Form from "react-bootstrap/Form"
import styles from "../submissionTeacher.module.scss"
import dashboardStyles from "components/Dashboards/General/general.module.scss"
import { MasteryTypes, Masteries } from "shared/types/moduleTypes"

interface Props {
    onChange: (val: string | null) => void
    subtopicId: string
    initialValue: MasteryTypes | null
    disabled?: boolean
}

export default function StandardsMasterySelection({ onChange, subtopicId, initialValue, disabled = false }: Props) {
    const [value, setValue] = React.useState(initialValue)

    return (
        <>
            {
            Masteries.map((item) => (
                <Col className="text-center" key={subtopicId + item}>
                    <Form.Check
                        value={item}
                        id={subtopicId + item}
                        checked={value === item}
                        disabled={disabled}
                        onChange={(e) => {
                            let newValue = null
                            if (e.currentTarget.value !== value) {
                                newValue = e.currentTarget.value
                            }
                            setValue(newValue)
                            onChange(newValue)
                        }}
                    />
                    <label
                        className={`${dashboardStyles.greyText} ${styles.standardsMasterLabel}`}
                        htmlFor={subtopicId + item}
                    >
                        {item}
                    </label>
                </Col>
            ))}
        </>
    )
}
